import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {NavigationConstant} from '@constant/navigation.constant';
import {RequestHelper} from '@helper/request.helper';
import {environment} from '@environments/environment';
import {APIConstant} from '@constant/api.constant';
import {PermataStorage} from '@storage/permata.storage';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-payment-permata',
  templateUrl: './payment-permata.component.html',
  styleUrls: ['./payment-permata.component.css']
})

export class PaymentPermataComponent implements OnInit {
    isSubmitted = false;
    isLoading: boolean;
    isSuccess: boolean;
    vaNumber: number;
    customerName: string;
    amount: string;
    hostname: any = environment.hostName;
    form: FormGroup;

  constructor(
      private router: Router,
      private storage: PermataStorage,
      private apiService: RequestHelper
  ) {
    this.isSuccess = true;
    this.isLoading = false;
    this.form = new FormBuilder().group({
        amount: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.vaNumber = this.storage.vaNumber;
    this.customerName = this.storage.data.GetBillRs.CUSTNAME;
    this.amount = this.storage.data.GetBillRs.BILL_AMOUNT;
  }

  submitPayment() {
      this.isSubmitted = true;
      if (!this.form.valid) {
          return;
      }
      const requestData = this.storage.data.GetBillRq;
      const responseData = this.storage.data.GetBillRs;
      const PayBillRq: any = {};

      PayBillRq.INSTCODE = requestData.INSTCODE;
      PayBillRq.VI_VANUMBER = requestData.VI_VANUMBER;
      PayBillRq.VI_TRACENO = requestData.VI_TRACENO;
      PayBillRq.VI_TRNDATE = requestData.VI_TRNDATE;
      PayBillRq.BILL_AMOUNT = this.amount;
      PayBillRq.VI_CCY = responseData.VI_CCY;
      PayBillRq.VI_DELCHANNEL = requestData.VI_DELCHANNEL;

      const params: any = {};
      params.PayBillRq = PayBillRq;

      this.isLoading = true;
      this.apiService.post(environment.apiUrl + APIConstant.PERMATA_PAYMENT, params).subscribe((data) => {
          this.storage.payment = data;
          this.storage.payment.amount = this.amount;
          this.storage.payment.customerName = this.customerName;
          this.storage.payment.vaNumber = requestData.VI_VANUMBER;
          return this.router.navigate([NavigationConstant.PERMATA_PAYMENT_RESULT]);
      }, () => this.isLoading = false);
    }

  openDialog(result) {
    this.apiService.openDialog(result, NavigationConstant.PERMATA_INQUIRY);
  }
}
